import { useTranslate } from '@repo/shared/hooks'
import { Row, Typography } from '@repo/ui/components'
import Image from 'next/image'
import { type OrderBoxPriceTimerProps } from './order-box.price-timer.types'
import * as React from 'react'

export const OrderBoxPriceTimer = (props: OrderBoxPriceTimerProps) => {
  const { onTimeExpired, initialTime = 30 } = props
  const { t } = useTranslate()

  const [timeLeft, setTimeLeft] = React.useState(initialTime)

  React.useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timer)
          onTimeExpired?.()
          return 0
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(timer)
  }, [onTimeExpired])

  React.useEffect(() => {
    setTimeLeft(initialTime)
  }, [initialTime])

  return (
    <Row className='justify-between min-h-[32px]'>
      <Row className='justify-center gap-sm'>
        <Image
          src='/images/circular-loading.svg'
          alt=''
          width={16}
          height={16}
          className='animate-spin'
        />
        <Typography size='sm' color='text-neutral-surface-80'>
          {t('order_price_validity', { seconds: timeLeft })}
        </Typography>
      </Row>
    </Row>
  )
}
